import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown';

export function getFilteredOptions(allItems: IBaseListDropdownOption<string | null>[], input: string) {
  return allItems.filter((item) => item.label.toLowerCase().includes(input.toLowerCase()));
}
